







































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestPaper from "@/store/entities/testPaper";
import ewebeditor from "@/components/ewebeditor.vue";

@Component({
  components: { ewebeditor },
})
export default class CreateTestPaper extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Boolean, default: false }) isrand: boolean;
  testPaper: TestPaper = new TestPaper();

  disciplinechapter: any = []; //所有学校
  editorContentConfig: any = {
    style: "coolblue",
    width: "100%",
    height: "200px",
  };
  frontendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  editorBackendurl: string = "https://manage.sxjy.cq.cn/dist/ewebeditor/";
  allTeam: any = [];
  teamName: any = []; //小组成员  选中的
  leader: any = []; // 组长
  teamLeader: any = []; //小组组长  选中的
  tabid: number = 0;
  formTitle: string = "人工组卷";
  BeginTime: string = "";
  EndTime: string = "";
  totalQuestions: number = 0;
  totalFractions: number = 0;
  questioncount: number = 0;
  selectedCascaderData: any = [];
  cadata: any = [];
  childparentId: number = 0;
  makepaper: false;
  questnumlist: string =
    "qTypeA0AstndA1,qTypeA0AstndA2,qTypeA0AstndA3,qTypeA1AstndA1,qTypeA1AstndA2,qTypeA1AstndA3,qTypeA2AstndA1,qTypeA2AstndA2,qTypeA2AstndA3,qTypeA3AstndA1,qTypeA3AstndA2,qTypeA3AstndA3,qTypeA4AstndA1,qTypeA4AstndA2,qTypeA4AstndA3,qTypeA8AstndA1,qTypeA8AstndA2,qTypeA8AstndA3,qTypeA9AstndA1,qTypeA9AstndA2,qTypeA9AstndA3,qTypeA10AstndA1,qTypeA10AstndA2,qTypeA10AstndA3,qTypeA11AstndA1,qTypeA11AstndA2,qTypeA11AstndA3,qTypeA12AstndA1,qTypeA12AstndA2,qTypeA12AstndA3,qTypeA7AstndA1,qTypeA7AstndA2,qTypeA7AstndA3,qTypeA5AstndA1,qTypeA5AstndA2,qTypeA5AstndA3,qTypeA6AstndA1,qTypeA6AstndA2,qTypeA6AstndA3";
  questfenlist: string =
    "fenAqTypeA0AstndA1,fenAqTypeA0AstndA2,fenAqTypeA0AstndA3,fenAqTypeA1AstndA1,fenAqTypeA1AstndA2,fenAqTypeA1AstndA3,fenAqTypeA2AstndA1,fenAqTypeA2AstndA2,fenAqTypeA2AstndA3,fenAqTypeA3AstndA1,fenAqTypeA3AstndA2,fenAqTypeA3AstndA3,fenAqTypeA4AstndA1,fenAqTypeA4AstndA2,fenAqTypeA4AstndA3,fenAqTypeA8AstndA1,fenAqTypeA8AstndA2,fenAqTypeA8AstndA3,fenAqTypeA9AstndA1,fenAqTypeA9AstndA2,fenAqTypeA9AstndA3,fenAqTypeA10AstndA1,fenAqTypeA10AstndA2,fenAqTypeA10AstndA3,fenAqTypeA11AstndA1,fenAqTypeA11AstndA2,fenAqTypeA11AstndA3,fenAqTypeA12AstndA1,fenAqTypeA12AstndA2,fenAqTypeA12AstndA3,fenAqTypeA7AstndA1,fenAqTypeA7AstndA2,fenAqTypeA7AstndA3,fenAqTypeA5AstndA1,fenAqTypeA5AstndA2,fenAqTypeA5AstndA3,fenAqTypeA6AstndA1,fenAqTypeA6AstndA2,fenAqTypeA6AstndA3";
  questchek = {
    fenAqTypeA0AstndA1: "",
    fenAqTypeA0AstndA2: "",
    fenAqTypeA0AstndA3: "",
    fenAqTypeA1AstndA1: "",
    fenAqTypeA1AstndA2: "",
    fenAqTypeA1AstndA3: "",
    fenAqTypeA2AstndA1: "",
    fenAqTypeA2AstndA2: "",
    fenAqTypeA2AstndA3: "",
    fenAqTypeA3AstndA1: "",
    fenAqTypeA3AstndA2: "",
    fenAqTypeA3AstndA3: "",
    fenAqTypeA4AstndA1: "",
    fenAqTypeA4AstndA2: "",
    fenAqTypeA4AstndA3: "",
    fenAqTypeA8AstndA1: "",
    fenAqTypeA8AstndA2: "",
    fenAqTypeA8AstndA3: "",
    fenAqTypeA9AstndA1: "",
    fenAqTypeA9AstndA2: "",
    fenAqTypeA9AstndA3: "",
    fenAqTypeA10AstndA1: "",
    fenAqTypeA10AstndA2: "",
    fenAqTypeA10AstndA3: "",
    fenAqTypeA11AstndA1: "",
    fenAqTypeA11AstndA2: "",
    fenAqTypeA11AstndA3: "",
    fenAqTypeA12AstndA1: "",
    fenAqTypeA12AstndA2: "",
    fenAqTypeA12AstndA3: "",
    fenAqTypeA7AstndA1: "",
    fenAqTypeA7AstndA2: "",
    fenAqTypeA7AstndA3: "",
    fenAqTypeA5AstndA1: "",
    fenAqTypeA5AstndA2: "",
    fenAqTypeA5AstndA3: "",
    fenAqTypeA6AstndA1: "",
    fenAqTypeA6AstndA2: "",
    fenAqTypeA6AstndA3: "",
    qTypeA0AstndA1: "",
    qTypeA0AstndA2: "",
    qTypeA0AstndA3: "",
    qTypeA1AstndA1: "",
    qTypeA1AstndA2: "",
    qTypeA1AstndA3: "",
    qTypeA2AstndA1: "",
    qTypeA2AstndA2: "",
    qTypeA2AstndA3: "",
    qTypeA3AstndA1: "",
    qTypeA3AstndA2: "",
    qTypeA3AstndA3: "",
    qTypeA4AstndA1: "",
    qTypeA4AstndA2: "",
    qTypeA4AstndA3: "",
    qTypeA8AstndA1: "",
    qTypeA8AstndA2: "",
    qTypeA8AstndA3: "",
    qTypeA9AstndA1: "",
    qTypeA9AstndA2: "",
    qTypeA9AstndA3: "",
    qTypeA10AstndA1: "",
    qTypeA10AstndA2: "",
    qTypeA10AstndA3: "",
    qTypeA11AstndA1: "",
    qTypeA11AstndA2: "",
    qTypeA11AstndA3: "",
    qTypeA12AstndA1: "",
    qTypeA12AstndA2: "",
    qTypeA12AstndA3: "",
    qTypeA7AstndA1: "",
    qTypeA7AstndA2: "",
    qTypeA7AstndA3: "",
    qTypeA5AstndA1: "",
    qTypeA5AstndA2: "",
    qTypeA5AstndA3: "",
    qTypeA6AstndA1: "",
    qTypeA6AstndA2: "",
    qTypeA6AstndA3: "",
  };
  questiontypelist: any = [
    {
      name: "判断题",
      list: [
        {
          id: "qTypeA0AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA0AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA0AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA0AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA0AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA0AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "单选题",
      list: [
        {
          id: "qTypeA1AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA1AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA1AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA1AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA1AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA1AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "多选题",
      list: [
        {
          id: "qTypeA2AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA2AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA2AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA2AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA2AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA2AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "填空题",
      list: [
        {
          id: "qTypeA3AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA3AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA3AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA3AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA3AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA3AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "计算题",
      list: [
        {
          id: "qTypeA4AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA4AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA4AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA4AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA4AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA4AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },

    {
      name: "解答题",
      list: [
        {
          id: "qTypeA8AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA8AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA8AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA8AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA8AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA8AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "作文题",
      list: [
        {
          id: "qTypeA9AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA9AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA9AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA9AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA9AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA9AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "探究题",
      list: [
        {
          id: "qTypeA10AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA10AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA10AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA10AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA10AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA10AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "材料题",
      list: [
        {
          id: "qTypeA11AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA11AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA11AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA11AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA11AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA11AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "实践题",
      list: [
        {
          id: "qTypeA12AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA12AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA12AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA12AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA12AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA12AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考单选",
      list: [
        {
          id: "qTypeA7AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA7AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA7AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA7AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA7AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA7AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考多选",
      list: [
        {
          id: "qTypeA5AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA5AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA5AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA5AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA5AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA5AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
    {
      name: "选考计算",
      list: [
        {
          id: "qTypeA6AstndA1",
          ctype: "1",
          background: "background-color: #efede1;",
        },
        {
          id: "fenAqTypeA6AstndA1",
          ctype: "2",
          background: "background-color: #efede1;",
        },
        {
          id: "qTypeA6AstndA2",
          ctype: "1",
          background: "background-color: #dbeff3;",
        },
        {
          id: "fenAqTypeA6AstndA2",
          ctype: "2",
          background: "background-color: #dbeff3;",
        },
        {
          id: "qTypeA6AstndA3",
          ctype: "1",
          background: "background-color: #cdc1d9;",
        },
        {
          id: "fenAqTypeA6AstndA3",
          ctype: "2",
          background: "background-color: #cdc1d9;",
        },
      ],
    },
  ];
  screenWidth: number = document.body.clientWidth - 200;
  questionStatistical: any = [
    {
      questionType: 0,
      questionTypeName: "判断题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 1,
      questionTypeName: "单选题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 2,
      questionTypeName: "多选题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 3,
      questionTypeName: "填空题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 4,
      questionTypeName: "计算题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 8,
      questionTypeName: "解答题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 9,
      questionTypeName: "作文题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 10,
      questionTypeName: "探究题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 11,
      questionTypeName: "材料题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 12,
      questionTypeName: "实践题",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 5,
      questionTypeName: "选考多选",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 6,
      questionTypeName: "选考计算",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
    {
      questionType: 7,
      questionTypeName: "选考单选",
      easyTotal: 0,
      middleTotal: 0,
      difficultTotal: 0,
      totalNumber: 0,
      totalAll: 0,
    },
  ];
  cascaderSelect(value, selectedData) {
    this.selectedCascaderData = selectedData;
    if (selectedData.length > 1) {
      this.childparentId = selectedData[1].id;
      this.getchildcascaderSelect();
    }

    if (selectedData.length > 0)
      this.testPaper.sectionId = selectedData[selectedData.length - 1].id;
    else this.testPaper.sectionId = 0;
    this.getTopicOfStatistical(this.testPaper.sectionId);
  }
  //获取试题难易分类统计
  getTopicOfStatistical(sectionId) {
    this.$store
      .dispatch({
        type: "testQuestion/getTopicOfStatistical",
        data: {
          sectionId: sectionId,
          BeginTime: this.BeginTime,
          EndTime: this.EndTime,
        },
      })
      .then((result) => {
        this.questionStatistical = result.items;
      });
  }
  async getchildcascaderSelect() {
    await this.$store.dispatch({
      type: "testQuestion/getNousCascader",
      data: { parentId: this.childparentId, classTypeId: 3 },
    });
    this.disciplinechapter = this.$store.state.testQuestion.cascaders.items;
    // console.log(this.$store.state.testQuestion.cascaders.items)
    // this.data = this.$store.state.testQuestion.cascaders.items
  }
  checkemoney(val, id) {
    let flag = new RegExp("^[0-9]([0-9])*$").test(val);
    if (!flag) {
      this.$Message.warning("只能输入正整数");
      this.$nextTick(() => {
        this.testPaper[id] = 0;
      });
      return false;
    } else {
      this.testPaper[id] = val;
    }
  }
  checkexaminationTime(val, id) {
    let flag = new RegExp("^[1-9]([0-9])*$").test(val);
    if (!flag) {
      this.$Message.warning("只能输入正整数");
      this.$nextTick(() => {
        this.testPaper[id] = 1;
      });
      return false;
    } else {
      this.testPaper[id] = val;
    }
  }
  categoryCheck = (rule: any, value: any, callback: any) => {
    if (this.testPaper.sectionId) {
    }
    if (this.selectedCascaderData && this.selectedCascaderData.length > 3) {
      callback();
    } else {
      callback(new Error("请选择末级"));
    }
  };
  examinationTimeCheck = (rule: any, value: number, callback: any) => {
    if (value > 0) {
      callback();
    } else {
      callback(new Error("必须大于0"));
    }
  };
  testPaperRule = {};
  checkallSchool(topren, children) {
    this.tabid = topren.value;
    this.allTeam = topren.children;
  }
  toRightLeader() {
    let moveName = this.torigntmatching(this.allTeam, this.teamName);
    if (
      moveName[0].id !== this.testPaper.sectionId &&
      !this.checkarr(this.leader, moveName[0].id)
    ) {
      //分类选中的节 是否等于范围内 选择添加的节
      this.getstatictalset(moveName[0].id);
    }
    let matArr = [];
    for (let i = 0; i < moveName.length; i++) {
      this.leader.push(moveName[i]);
    }
    let arr1 = this.unique(this.leader);
    this.leader = arr1;
    this.teamName = [];
  } //获取试题难易分类统计
  checkarr(arr, id) {
    for (var i = 0; i < arr.length; i++) {
      if (id === arr[i]["id"]) {
        return true;
      }
    }
    return false;
  }
  getstatictalset(sectionId) {
    let _this = this;
    this.$store
      .dispatch({
        type: "testQuestion/getTopicOfStatistical",
        data: {
          sectionId: sectionId,
          BeginTime: this.BeginTime,
          EndTime: this.EndTime,
        },
      })
      .then((result) => {
        //  this.questionStatistical = result.items;
        let b = result.items;
        _this.questionStatistical.forEach(function(item, index) {
          _this.questionStatistical[index]["difficultTotal"] =
            item["difficultTotal"] + b[index]["difficultTotal"];
          _this.questionStatistical[index]["easyTotal"] =
            item["easyTotal"] + b[index]["easyTotal"];
          _this.questionStatistical[index]["middleTotal"] =
            item["middleTotal"] + b[index]["middleTotal"];
          _this.questionStatistical[index]["totalAll"] =
            item["totalAll"] + b[index]["totalAll"];
        });
      });
  }

  unique(arr) {
    const res = new Map();
    return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
  }
  torigntmatching(allArr, matchArr) {
    let matArr = [];
    for (let i = 0; i < allArr.length; i++) {
      for (let j = 0; j < matchArr.length; j++) {
        if (allArr[i].value == matchArr[j]) {
          matArr.push(allArr[i]);
        }
      }
    }
    return matArr;
  }
  torigntmyFilter(allArr, selArr) {
    let ary03 = [];
    for (let i = 0; i < allArr.length; i++) {
      for (let j = 0; j < selArr.length; j++) {
        if (allArr[i].value == selArr[j].value) {
          allArr.splice(i, 1);
        }
      }
    }
    return allArr;
  }

  toLeftTeam() {
    let moveName = this.matching(this.leader, this.teamLeader);
    if (moveName[0].id !== this.testPaper.sectionId) {
      //分类选中的节 是否等于范围内 选择添加的节
      this.getstatictaldel(moveName[0].id);
    }
    let allArr = this.myFilter(this.leader, moveName);
    this.leader = allArr;
    this.teamLeader = [];
  }
  getstatictaldel(sectionId) {
    let _this = this;
    this.$store
      .dispatch({
        type: "testQuestion/getTopicOfStatistical",
        data: {
          sectionId: sectionId,
          BeginTime: this.BeginTime,
          EndTime: this.EndTime,
        },
      })
      .then((result) => {
        //  this.questionStatistical = result.items;
        let b = result.items;
        _this.questionStatistical.forEach(function(item, index) {
          _this.questionStatistical[index]["difficultTotal"] =
            item["difficultTotal"] - b[index]["difficultTotal"];
          _this.questionStatistical[index]["easyTotal"] =
            item["easyTotal"] - b[index]["easyTotal"];
          _this.questionStatistical[index]["middleTotal"] =
            item["middleTotal"] - b[index]["middleTotal"];
          _this.questionStatistical[index]["totalAll"] =
            item["totalAll"] - b[index]["totalAll"];
        });
      });
  }
  // 过滤 相同选项
  myFilter(allArr, selArr) {
    let ary03 = [];
    for (let i = 0; i < allArr.length; i++) {
      for (let j = 0; j < selArr.length; j++) {
        if (allArr[i].value == selArr[j].value) {
          allArr.splice(i, 1);
        }
      }
    }
    return allArr;
  }
  //  匹配 移动的 选项
  matching(allArr, matchArr) {
    let matArr = [];
    for (let i = 0; i < allArr.length; i++) {
      for (let j = 0; j < matchArr.length; j++) {
        if (allArr[i].value == matchArr[j]) {
          matArr.push(allArr[i]);
        }
      }
    }
    return matArr;
  }
  checktestquestionsfencount() {
    let question_fencount = true;
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    let inputvalue;
    let qinputvalue;
    for (var i = 0; i < idlist.length; i++) {
      inputvalue = this.questchek[idlist[i]];
      qinputvalue = this.questchek[qidlist[i]];
      if (inputvalue && !qinputvalue) {
        question_fencount = false;
      }
      if (!inputvalue && qinputvalue) {
        question_fencount = false;
      }
    }
    return question_fencount;
  }

  save() {
    (this.$refs.testPaperForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (!this.checktestquestionsfencount()) {
          this.$Message.error("试题数或试题分数未设置完成!");
          return false;
        }
        if (!this.testPaper.name) {
          this.$Message.error("请填写试卷名称!");
          return false;
        }
        if (this.selectedCascaderData.length > 0) {
          if (this.selectedCascaderData.length < 4) {
            this.$Message.warning("分类未选择到末级!");
            return false;
          }
        } else {
          this.$Message.warning("请选择分类");
          return false;
        }
        if (!this.testPaper.examinationTime) {
          this.$Message.error("请填写答题时间!");
          return false;
        }

        if (!this.testPaper.totalQuestion) {
          this.$Message.error("请填写试卷总题数!");
          return false;
        }
        if (!this.testPaper.totalFraction) {
          this.$Message.error("请填写试卷总分数!");
          return false;
        }

        if (
          Number(this.testquestioncount()) !==
            Number(this.testPaper.totalQuestion) ||
          Number(this.testquestionsfencount()) !==
            Number(this.testPaper.totalFraction)
        ) {
          this.$Message.error("试题未设置完!");
          return false;
        }

        //return false;
        //题数统计
        this.questionTypeAndAmount();
        //分数统计
        this.questionTypeAndFraction();
        let selectRange = [];
        this.leader.forEach((item) => {
          selectRange.push(item.value);
        });
        this.testPaper.gradeType = 1;
        this.testPaper.rangeSectionChapters = selectRange.toString();
        //   this.testPaper.description = (this.$refs["ewe"] as any).getHtmleweb();
        this.testPaper.testPaperCreateType = 2;
        if (this.isrand) {
          this.testPaper.handMadeRandom = 1;
        } else {
          this.testPaper.handMadeRandom = 0;
        }
        await this.$store
          .dispatch({
            type: "testPaper/create",
            data: this.testPaper,
          })
          .then((res) => {
            (this.$refs.testPaperForm as any).resetFields();
            this.initAllNumber();
            this.testPaper.questionTypeAndFraction = "";
            this.testPaper.questionTypeAndAmount = "";
            this.disciplinechapter = [];
            this.allTeam = [];
            this.leader = [];
            //  this.selectedCascaderData = [];

            if (!this.isrand) {
              this.$emit("save-success");
              this.$emit("input", false);
            }
            if (this.isrand) {
              this.createRandomGroup(res.id);
            }
            //  console.log(res);
          })
          .catch((err) => {});
      }
    });
  }
  async createRandomGroup(id) {
    await this.$store
      .dispatch({
        type: "testPaper/createRandomGroup",
        data: { id: id },
      })
      .then((res) => {
        this.$emit("save-success");
        this.$emit("input", false);
        console.log(res);
      })
      .catch((err) => {});
  }
  questionTypeAndAmount() {
    let idlist = this.questnumlist.split(",");
    for (var i = 0; i < idlist.length; i++) {
      let questionNum = this.questchek[idlist[i]];
      questionNum = questionNum > 0 ? questionNum : 0;
      if (!this.testPaper.questionTypeAndAmount)
        this.testPaper.questionTypeAndAmount = idlist[i] + "," + questionNum;
      else
        this.testPaper.questionTypeAndAmount +=
          "|" + idlist[i] + "," + questionNum;
    }
  }
  questionTypeAndFraction() {
    // let question_fencount = 0;
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    // let inputvalue;
    let qinputvalue;
    for (var i = 0; i < idlist.length; i++) {
      // inputvalue = Number(this.questchek[idlist[i]]);
      qinputvalue = Number(this.questchek[qidlist[i]]);
      // question_fencount = Number(inputvalue) * Number(qinputvalue);
      if (!this.testPaper.questionTypeAndFraction)
        this.testPaper.questionTypeAndFraction = qidlist[i] + "," + qinputvalue;
      else
        this.testPaper.questionTypeAndFraction +=
          "|" + qidlist[i] + "," + qinputvalue;
    }
  }
  cancel() {
    (this.$refs.testPaperForm as any).resetFields();
    this.$emit("input", false);
  }
  initAllNumber() {
    this.resetestquestionsfencount();
    this.testPaper.totalFraction = 0;
    this.testPaper.totalQuestion = 0;
    this.testPaper.examinationTime = 0;
    this.testPaper.money = 0;
  }
  //试题类型统计

  visibleChange(value: boolean) {
    if (this.isrand) {
      this.formTitle = "随机组卷";
    } else {
      this.formTitle = "人工组卷";
    }
    this.cadata = this.$store.state.testPaper.cascaders.items;
    if (!value) {
      this.initAllNumber();
      (this.$refs.testPaperForm as any).resetFields();
      this.$emit("input", value);
    } else {
      this.getTopicOfStatistical(0);
      // this.setEditorDataInit();
    }
  }
  setEditorDataInit() {
    //  (this.$refs["ewe"] as any).setHtmleweb("");
  }
  checktotalFraction(val, id) {
    this.resetestquestionsfencount();
    let flag = new RegExp("^[1-9]([0-9])*$").test(val);
    if (!flag) {
      this.$Message.warning("只能输入正整数");
      this.$nextTick(() => {
        this.testPaper[id] = 0;
      });
      return false;
    } else {
      if (id == "totalQuestion") {
        this.totalQuestions = val;
      } else {
        this.totalFractions = val;
      }
      this.testPaper[id] = val;
    }
  }

  numValid(val, id, ctype) {
    /**  if (!this.testPaper.totalQuestion) {
      this.$Message.warning("请先输入试题总数");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    }
    if (!this.testPaper.totalFraction) {
      this.$Message.warning("请先输入试卷总分");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    }
 */
    var reg = /(^([-]?)[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9]\.[0-9]([0-9])?$)/;

    if (val != "" && val != undefined) {
      if (!reg.test(val)) {
        this.$Message.warning("只能输入正整数");
        this.$nextTick(() => {
          this.questchek[id] = "";
        });
        return false;
      } else {
        this.questchek[id] = val;
        /** 
        if (ctype == 1) {
          if (val > this.testPaper.totalQuestion) {
            this.questchek[id] = "";
            return false;
          } else {
            this.questchek[id] = val;
          }
        } else {
          if (val > this.testPaper.totalFraction) {
            this.questchek[id] = "";
            return false;
          } else {
            this.questchek[id] = val;
          }
        }*/
      }
    }

    //FtestPaper totalQuestion

    this.questioncount = this.testquestioncount();
    let fractions = this.testquestionsfencount();
    /*if (this.questioncount > this.testPaper.totalQuestion) {
      this.$Message.warning("输入的试题数量已经超过试题总数");
      this.$nextTick(() => {
        this.questchek[id] = "";
      });
      return false;
    } else {
      this.totalQuestions = this.testPaper.totalQuestion - this.questioncount;
    }*/
    this.testPaper.totalQuestion = this.questioncount;
    let questionfencount = this.testquestionfencount();
    /** if (ctype == 2) {
      if (Number(this.testquestionfencount()) > this.testPaper.totalFraction) {
        this.$Message.warning("输入的试题分数已经超过试题总分数");
        this.$nextTick(() => {
          this.questchek[id] = "";
          return false;
        });
      } else {
        this.totalFractions = this.testPaper.totalFraction - questionfencount;
      }
    } */
    this.testPaper.totalFraction = this.testquestionsfencount();
    /** if (Number(this.testquestionsfencount()) > this.testPaper.totalFraction) {
      this.$Message.warning("输入的试题分数相加，已经超过试卷总分");
      this.$nextTick(() => {
        this.questchek[id] = "";
        return false;
      });
    } else {
      this.totalFractions = this.testPaper.totalFraction - fractions;
    } */
  }
  testquestionfencount() {
    let qidlist = this.questfenlist.split(",");
    let _this = this;
    let sum = 0;
    for (var i = 0; i < qidlist.length; i++) {
      sum += Number(_this.questchek[qidlist[i]]);
    }

    return sum;
  }
  testquestioncount() {
    let idlist = this.questnumlist.split(",");
    let sum = 0;
    for (var i = 0; i < idlist.length; i++) {
      sum += Number(this.questchek[idlist[i]]);
    }
    return sum;
  }
  testquestionsfencount() {
    let question_fencount = 0;
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    let inputvalue;
    let qinputvalue;
    for (var i = 0; i < idlist.length; i++) {
      inputvalue = this.questchek[idlist[i]];
      qinputvalue = this.questchek[qidlist[i]];
      question_fencount += Number(inputvalue) * Number(qinputvalue);
    }
    return question_fencount;
  }
  resetestquestionsfencount() {
    let idlist = this.questnumlist.split(",");
    let qidlist = this.questfenlist.split(",");
    for (var i = 0; i < idlist.length; i++) {
      this.questchek[idlist[i]] = "";
      this.questchek[qidlist[i]] = "";
    }
  }
}
